import React, { FC, ReactElement, useCallback, useState } from 'react';
import { FormContainer, SourceCustomFormContainer } from './styles';
import * as C from '../../styles';

import {
  Button,
  VisibilityIcon,
  VisibilityOffIcon,
  IconButton,
} from '@cherre-frontend/ui';
import {
  useCustomSource,
  useSaveCustomSourceFormFirstStep,
} from 'src/products/connector/pages/add-connector/dataState';
import { useConnectorUIState } from 'src/products/connector/pages/add-connector/uiState/contexts';

const SourceCustomFormFirstStep: FC = (): ReactElement => {
  const [{ chosenSource }] = useConnectorUIState();
  const [value, setCustomSource] = useCustomSource();
  const [showPassword, setShowPassword] = useState(false);
  const [canSave, nextStep, closeStep] = useSaveCustomSourceFormFirstStep(
    chosenSource?.configuration?.fields
  );

  const handleNextStep = useCallback(() => {
    setTimeout(() => nextStep(), 0);
  }, [nextStep]);

  const handleCancel = useCallback(() => {
    closeStep();
  }, [closeStep]);

  return (
    <SourceCustomFormContainer>
      <C.Title>Configure your source:</C.Title>

      <FormContainer>
        {chosenSource?.configuration?.fields.map((field) => (
          <C.FieldBox key={field.envVarName}>
            <C.FieldTitle>{field.description}</C.FieldTitle>
            <C.FieldInput
              size='small'
              disabled={field.envVarName === 'SFTP_USER'}
              value={value.form?.[field.secretName || field.envVarName]}
              onChange={(e) => {
                if (!value.form) {
                  value.form = {};
                }

                value.form[field.secretName || field.envVarName] =
                  e.target.value;
                setCustomSource({ ...value });
              }}
              inputProps={{
                'data-testid': `sftp-source-${field.type}`,
                type:
                  field.type === 'password' && !showPassword
                    ? 'password'
                    : 'text',
              }}
              InputProps={{
                endAdornment:
                  field.type === 'password' ? (
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  ) : null,
              }}
            />
          </C.FieldBox>
        ))}
      </FormContainer>
      <C.Actions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          disabled={!canSave}
          onClick={handleNextStep}
          variant='contained'
        >
          Next
        </Button>
      </C.Actions>
    </SourceCustomFormContainer>
  );
};

export default SourceCustomFormFirstStep;
